export default __webpack_public_path__ + "static/media/i_bus-low_yl.bbe19c7d.svg";